module.exports = __webpack_public_path__ + "static/media/kelta-valkovuori.24357ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kelta-valkovuori.png
// module id = 63
// module chunks = 0